<template>
  <CurrentEventDataProvider v-slot="{ designStyles }">
    <div
      class="relative px-6 md:px-12 py-6 flex flex-col"
      :style="designStyles"
    >
      <button
        type="button"
        class="absolute top-3 right-3 w-8 h-8 rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 flex items-center justify-center transition-colors"
        :aria-label="$t('Components.shared.Navbar.close', tLocale)"
        @click="$emit('close')"
      >
        <i class="fal fa-times text-lg" aria-hidden="true"></i>
      </button>
      <div
        class="flex flex-col items-center h-full mb-1 md:mb-2"
        v-if="profile"
      >
        <div class="text-base md:text-md font-bold pb-6">
          {{ $t('Components.shared.Navbar.myTicket', tLocale) }}
        </div>
        <div class="flex items-center justify-center pb-1 md:pb-6 lg:pb-0">
          <qrcode-vue
            :value="profile.TicketQrCode"
            :size="qrCodeSize"
            render-as="svg"
            level="H"
          />
        </div>
      </div>
    </div>
  </CurrentEventDataProvider>
</template>
<script>
import { mapGetters } from 'vuex';
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'TicketModal',
  components: { QrcodeVue },
  props: {
    // Opened both from the AI Matcher dashboard (English-only) and from the lobby navbar /
    // stage profile, which follow the event language. Only the AI Matcher caller passes true.
    english: { type: Boolean, default: false }
  },
  data() {
    return { windowWidth: window.innerWidth };
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  },
  computed: {
    tLocale() {
      return this.english ? 'en' : this.$i18n.locale;
    },
    ...mapGetters('Authentication', {
      profile: 'getUser'
    }),
    qrCodeSize() {
      return Math.min(Math.max(parseInt(this.windowWidth / 2), 100), 300);
    }
  }
};
</script>
